import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UIAdminRole } from 'components/admin/roles/types/role'

interface AdminRoleState {
  roles: UIAdminRole[]
  isLoading: boolean
  error: null
}

const initialState: AdminRoleState = {
  roles: [],
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'admin-roles',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Admin Roles
    getAllAdminRoles(state, action: PayloadAction<UIAdminRole[]>) {
      state.isLoading = false
      state.roles = action.payload
      state.error = null
    },
    // Amend role details
    amendExistingRoles(
      state,
      action: PayloadAction<{ roleIdentifier: string; commonName: string }>
    ) {
      // any because the object is custom
      state.isLoading = false
      state.roles = state.roles.map((role) =>
        role?.roleIdentifier === action.payload.roleIdentifier
          ? {
              ...role,
              commonName: action.payload.commonName // Update commonName
            }
          : role
      )
      state.error = null
    },
    // Append Role Details
    appendToRoleDetails(
      state,
      action: PayloadAction<UIAdminRole>
    ) {
      // any because the object is custom
      state.isLoading = false
      state.roles = [action.payload, ...state.roles]
      state.error = null
    },
    clearAllAdminRoles(state) {
      state.isLoading = false
      state.roles = []
      state.error = null
    }
  }
})

// Reducer
export const { getAllAdminRoles, hasError, startLoading, clearAllAdminRoles, amendExistingRoles, appendToRoleDetails } =
  slice.actions
export default slice.reducer
